/* eslint-disable camelcase */

// Used to create backgorund customized to echart
// function getDataUrl(img) {
//   // Create canvas
//   const canvas = document.createElement('canvas');
//   const ctx = canvas.getContext('2d');
//   // Set width and height
//   canvas.width = 1;
//   canvas.height = 1;
//   // Draw the image
//   ctx.drawImage(img, 0, 0, 1, 1);
//   return canvas.toDataURL();
// }
// function areaColorStyle() {
//   // for image
//   const img = document.createElement('img');
//   img.src = 'http://s14.directupload.net/images/111129/44ga9qid.png';
//   return {
//     image: img,
//   };
//   // for linear gradient
//   // return {
//   //   type: 'linear',
//   //   x: 0,
//   //   y: 0,
//   //   x2: 0,
//   //   y2: 1,
//   //   colorStops: [{
//   //       offset: 0, color: 'red' // color at 0% position
//   //   }, {
//   //       offset: 1, color: 'blue' // color at 100% position
//   //   }],
//   //   global: false // false by default
//   // }
// }

import echarts from 'echarts/lib/echarts';

function hexToRgb(hex) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16),
  } : null;
}

function shorting(text) {
  const maxLines = 2;
  const maxLength = 15;
  const sub = text.split(' ');
  let result = '';
  let remain = maxLength;
  let countLines = 0;
  for (let i = 0; i < sub.length; i += 1) {
    // break condition by max lines
    if (countLines === (maxLines - 1)) {
      result += '...';
      break;
    }
    // add break line or join
    const lc = sub[i].length + 1;
    if (lc > remain) {
      result = `${result}\n${sub[i]}`;
      remain = maxLength - lc;
      countLines += 1;
    } else {
      result = result + (result ? ' ' : '') + sub[i];
      remain -= lc;
    }
  }
  return result;
}

function selectStyleColor(theme, index, kind) {
  const { colors } = theme;
  const { r, g, b } = hexToRgb(colors[index % colors.length]);
  if (kind) {
    return {
      color: new echarts.graphic.LinearGradient(
        0, 0, 0, 1,
        [
          { offset: 0, color: `rgba(${r * 0.5},${g * 0.5},${b * 0.5}, 1)` }, // color at 0% position
          { offset: 0.5, color: `rgba(${r}, ${g}, ${b}, 0.3)` }, // color at 50% position
          { offset: 1, color: theme.simulation.gradientTargetColor }, // color at 100% position
        ],
      ),
      borderColor: `rgba(${r * 0.8},${g * 0.8},${b * 0.8}, 1)`,
      borderWidth: 2,
      borderType: 'dashed',
      // color: areaColorStyle(),
    };
  }
  return {
    color: `rgba(${r},${g},${b},1)`,
  };
}


export function toEchartData(data, theme) {
  // initializing source
  const { alternativas } = data;
  const data0 = alternativas.map((a) => a.resultado_percentual);
  const data1 = alternativas.map((a) => a.resultado_simulado_percentual);
  const xlabels = alternativas.map((a) => ({
    value: shorting(a.enunciado),
    textStyle: { fontSize: 9, color: theme.axis.x.label },
  }));
  const { legend } = theme;
  //
  const options = {
    grid: {
      show: false,
      left: '5%',
      right: '3%',
      bottom: '15%',
      top: '15%',
    },
    legend: {},
    tooltip: {},
    xAxis: [{
      type: 'category',
      data: xlabels,
      axisTick: {
        alignWithLabel: true,
      },
      axisPointer: {
        type: 'shadow',
      },
      axisLine: {
        lineStyle: {
          color: theme.axis.x.label,
        },
      },
    }],
    yAxis: {
      axisLine: {
        lineStyle: {
          color: theme.axis.x.label,
        },
      },
    },
    // Declare several bar series, each will be mapped
    // to a column of dataset.source by default.
    series: [
      {
        type: 'bar',
        barGab: '20%',
        label: {
          show: true,
          position: 'top',
          formatter: '{c}%',
          textBorderWidth: 0,
          color: legend.color,
        },
        data: data0.map((value, index) => ({
          value: value.toFixed(1), itemStyle: selectStyleColor(theme, index, 0),
        })),
      },
      {
        type: 'bar',
        barGab: '20%',
        label: {
          show: true,
          position: 'top',
          formatter: '{c}%',
          textBorderWidth: 0,
          color: legend.color,
        },
        data: data1.map((value, index) => ({
          value: value.toFixed(1), itemStyle: selectStyleColor(theme, index, 1),
        })),
      },
    ],
  };
  //
  return options;
}
